import React from 'react';
import { trimAllSpace } from '@utiljs/string';
import { failToast } from '@utils/toast';
import Input from '@roo/roo/Input';
import Icon from '@roo/roo/Icon';
import * as LX from '@utils/lxWrapper';
import * as Ids from '@utils/ids';
import { getGrayStateByToken, GRAY_AB_TOKEN } from '@utils/grayAB';
import styles from './OrderSearch.module.scss';

const { useCallback, useState } = React;

const OrderSearch: React.FC = () => {
    const [searchVal, setSearchVal] = useState('');

    const handleSearch = useCallback(() => {
        /** 餐饮新形态灰度 */
        const UNIFIED_ORDER_GRAY = getGrayStateByToken(GRAY_AB_TOKEN.UNIFIED_ORDER);
        if (/<|>/.test(searchVal) || !searchVal) {
            failToast('输入不能为空或包含特殊字符');
            return;
        }
        const item = trimAllSpace(searchVal);
        LX.reportMC('b_waimai_e_zy1ibwlc_mc', 'c_waimai_e_fa4ps4ng', {
            acctId: Ids.getAcctId(),
            keyword: item,
        });
        const hash = UNIFIED_ORDER_GRAY
            ? `/new_fe/orderbusiness#/order/search?searchItem=${trimAllSpace(item)}`
            : `/new_fe/business#/order/search?searchItem=${trimAllSpace(item)}`;
        document.location.hash = hash;
    }, [searchVal]);

    const onSearchValKeyUp = useCallback(
        e => {
            if (e.keyCode === 13) {
                handleSearch();
            }
        },
        [handleSearch],
    );

    const onSearchValChange = useCallback(
        e => {
            setSearchVal(e.target.value);
        },
        [setSearchVal],
    );

    return (
        <div className={`${styles.container} global-order-search-contain`}>
            <Input
                prefix={<Icon onClick={handleSearch} name="search" />}
                styleType="plaintext"
                placeholder="支持输入订单流水号、商品名称、订单号、手机尾号（4位）、顾客地址进行搜索"
                onChange={onSearchValChange}
                onKeyUp={onSearchValKeyUp}
            />
        </div>
    );
};

export default OrderSearch;
